import { useContext, useState } from "react";
import { LocaleContext } from "../../contexts/locale/locale";
import classes from "./objects.module.css";

export const Objects = () => {
	const { texts } = useContext(LocaleContext);

	/* ALWAYS SYNC TIMEOUT IN THIS CLASS AND TRANSITION TIME IN CSS FILE*/

	const images = [
		"/images/objects/berlin.png",
		"/images/objects/bonn.png",
		"/images/objects/hamm.png",
	];

	const [current, setCurrent] = useState(0);
	const [currentBubble, setCurrentBubble] = useState(0);
	const [animatingLeft, setAnimatingLeft] = useState(false);
	const [animatingRight, setAnimatingRight] = useState(false);

	const timeout = 300;

	const getFive = () => {
		return [0, 1, 2, 3, 4].map(
			(i) => images[(i + current + images.length) % images.length]
		);
	};

	const swipeLeft = () => {
		if (animatingLeft || animatingRight) return;
		setCurrentBubble((c) => (c + 1) % images.length);
		setAnimatingLeft(true);
		setTimeout(() => {
			setCurrent((c) => (c + 1) % images.length);
			setAnimatingLeft(false);
		}, timeout);
	};

	const swipeRight = () => {
		if (animatingLeft || animatingRight) return;
		setCurrentBubble((c) => (c - 1) % images.length);
		setAnimatingRight(true);
		setTimeout(() => {
			setCurrent((c) => (c - 1) % images.length);
			setAnimatingRight(false);
		}, timeout);
	};

	return (
		<div className={classes["objects-container"]} id="objects">
			<h3>{texts.objects.title}</h3>
			<div id="objects" className={classes["objects-carousel"]}>
				<div
					style={
						animatingLeft || animatingRight
							? { transition: timeout / 1000 + "s" }
							: {}
					}
					className={
						animatingLeft
							? classes["carousel-container"] +
							  " " +
							  classes["carousel-container-animating-left"]
							: animatingRight
							? classes["carousel-container"] +
							  " " +
							  classes["carousel-container-animating-right"]
							: classes["carousel-container"] +
							  " " +
							  classes["carousel-container-not-animating"]
					}
				>
					{getFive().map((e, i) => (
						<div key={i} className={classes["carousel-element"]}>
							<div
								className={classes["carousel-image"]}
								style={{ backgroundImage: "url(" + e + ")" }}
							>
								&nbsp;
							</div>
						</div>
					))}
				</div>
				<div className={classes["carousel-arrows"]}>
					<button name="chevron-left" onClick={swipeRight}>
						<img alt="Left" src="/icons/objects/chevron-left.svg" />
					</button>
					<button name="chevron-right" onClick={swipeLeft}>
						<img alt="Right" src="/icons/objects/chevron-right.svg" />
					</button>
				</div>
			</div>
			<div
				className={
					animatingLeft || animatingRight
						? classes["objects-description"] +
						  " " +
						  classes["objects-description-animating"]
						: classes["objects-description"]
				}
			>
				<h3>{texts.objects.elements[(current + 2) % images.length].title}</h3>
				<p>
					{texts.objects.elements[(current + 2) % images.length].description}
				</p>
			</div>
			<div className={classes["objects-bubbles"]}>
				{images.map((e, i) => (
					<div
						key={i}
						className={
							classes["objects-bubble"] +
							" " +
							((currentBubble + images.length) % images.length === i
								? classes["large"]
								: classes["small"])
						}
					>
						&nbsp;
					</div>
				))}
			</div>
		</div>
	);
};
